import http from './http';
import Configuration from './domain/Configuration';
import Link from './domain/Link';
import Meta from './domain/Meta';
import Resource from './domain/Resource';
import Collection, { Response } from './domain/Collection';
import MetaOverrideSet from './domain/MetaOverrideSet';
import {login} from './actions';
import Connection from './domain/Connection';
import queries from './consts/queries';
import relationships from './consts/relationships';

export default {
  meta: v => (new Meta({ data: v })),
  resource: (data, override) => (new Resource({ data, metaOverrideSet: override })),
  http,
  Meta,
  Resource,
  Collection,
  Response,
  response: (data, override, cookie) => (new Response({
    data,
    metaOverrideSet: override,
    connection: cookie ? new Connection({data: {authToken: cookie}}) : null,
  })),
  Link,
  collection: (data, override, cookie) => (new Collection({
    data,
    metaOverrideSet: override,
    connection: cookie ? new Connection({data: {authToken: cookie}}) : null,
  })),
  config: Configuration,
  metaOverride: (args) => new MetaOverrideSet(args),
  login,
  link: (args) => new Link(args),
  relationships,
  queries,
};
